/**
 * Created by matthiasprinz on 12.08.17.
 */
import feeTable from '../reducers/feeTable';
import courtFeeTable from '../reducers/gkgTable';

export function getFeeForMatterValue(matterValue) {
// implements § 13 Abs. 1 RVG
  function getFeeOver500k(matterValue) {
    // Höchstgrenze § 22 Abs. 2 S. 1 RVG
    matterValue = (matterValue >= 30000000) ? 30000000 : matterValue;
    const factor = Math.ceil((matterValue - 500000) / 50000);
    return factor * 165;
  }


  if (matterValue > 500000) {
    return feeTable().reverse()[0].fee + getFeeOver500k(matterValue);
  }
  const firstFind = feeTable().find((fee) => {
    return fee.valueOfMatter >= matterValue;
  });
    // firstFind = firstFind ? firstFind : feeTable.reverse().first()
  return firstFind.fee;
}

export function currency(amount) {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
}

export function getCourtFeesForMatterValue(matterValue) {
  function getFeeOver500k(matterValue) { // § 34 GKG
    matterValue = (matterValue >= 300000000) ? 300000000 : matterValue;
    const factor = Math.ceil((matterValue - 500000) / 50000);
    return factor * 180;
  }

  if (matterValue > 500000) {
    return courtFeeTable().reverse().first().fee + getFeeOver500k(matterValue);
  }
  const firstFind = courtFeeTable().find((fee) => {
    return fee.valueOfMatter >= matterValue;
  });
  // firstFind = firstFind ? firstFind : feeTable.reverse().first()
  return firstFind.fee;
}



// WEBPACK FOOTER //
// ./src/services/services.js